import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Text from '../Text';

/**
 * Extends `Text`
 *
 * A utility component that quickly allows you to add helpful messages to form fields
 * */
var FormHelperText = function FormHelperText(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    fontSize: "small",
    color: "gray-300"
  }, props));
};

export default FormHelperText;